import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { setPickupProperties } from 'src/app/STORE/actions/propertypane.actions';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import { setFieldsForTable } from 'src/app/STORE/actions/services.actions';
import { forkJoin } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PickupListService {
  private store = inject(Store);
  private loader = inject(AppLoaderService);
  private http = inject(HttpBaseService);

  picklist = {
    fields: [],
    tables: [],
    primaryFields: [],
    allFields: [],
    noImgFAFields: [],
    lookupFields: [],
    indexFields: []
  };

  configurePickupList(tableId, plist?) {
    this.store.dispatch(setPickupProperties({ picklist: null }));
    this.loader.show();
    this.store.dispatch(setFieldsForTable({ tblFields: null }));
    const picklist = plist ? plist : { ...this.picklist };

    const fieldsAndSearchInfo$ = forkJoin({
      data: this.http['get'](ApiConstants.getFieldInfo, { tableId: tableId }),
      searchableFieldsData: this.http['get'](ApiConstants.getSearchableIndexFields, { tableId: tableId }),
    });
    fieldsAndSearchInfo$.subscribe({
      next: ({ data, searchableFieldsData }) => {
        const searchData = (searchableFieldsData && Array.isArray(searchableFieldsData))
          ? searchableFieldsData.map((field: any) => field.fieldSid)
          : [];
        this.configureList(data, searchData, picklist)
      }, error: () => {
        this.loader.hide();
      }
    })

  }
  configureList(data: any, searchData: any, picklist: any) {
    try {
      if (data) {
        const primaryFields = data
          .filter((fld) => {
            return (
              (fld.f_type.toLowerCase() === 'number' ||
                fld.f_type.toLowerCase() === 'string' ||
                fld.f_type.toLowerCase() === 'dropdown' ||
                fld.f_type.toLowerCase() === 'lookup' ||
                fld.f_type.toLowerCase() === 'datetime' ||
                fld.f_type.toLowerCase() === 'checkboxgroup' ||
                fld.f_type.toLowerCase() === 'checkbox' ||
                fld.f_type.toLowerCase() === 'currency' ||
                fld.f_type.toLowerCase() === 'date' ||
                fld.f_type.toLowerCase() === 'double' ||
                fld.f_type.toLowerCase() === 'email' ||
                fld.f_type.toLowerCase() === 'json' ||
                fld.f_type.toLowerCase() === 'radio' ||
                fld.f_type.toLowerCase() === 'color') &&
              !fld.f_hasMultiVal &&
              !fld.f_transientField &&
              fld.name.toLowerCase() !== 'id'
            );
          })
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        const fields = data
          .filter((fld) => {
            return searchData.includes(fld.sid);
          })
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        const lookupFields = data
          .filter((fld) => {
            return (
              searchData.includes(fld.sid) &&
              !fld.f_hasMultiVal &&
              fld.f_type.toLowerCase() !== 'image carousel' &&
              fld.f_type.toLowerCase() !== 'file attachments' &&
              fld.f_type.toLowerCase() !== 'complex datatype' &&
              !fld.f_transientField
            );
          })
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        const uniqueFields = data
          .filter((fld) => {
            return (
              fld.f_type.toLowerCase() !== 'image carousel' &&
              fld.f_type.toLowerCase() !== 'file attachments' &&
              fld.f_type.toLowerCase() !== 'complex datatype' &&
              !fld.f_transientField
            );
          })
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        const noImgFAFields = data
          .filter((fld) => {
            return (
              fld.f_type.toLowerCase() !== 'image carousel' &&
              fld.f_type.toLowerCase() !== 'file attachments' &&
              fld.f_type.toLowerCase() !== 'checkboxgroup' &&
              fld.f_type.toLowerCase() !== 'complex datatype' &&
              !fld.f_sysF
            );
          })
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        const indexFields = data
          .filter((fld) => {
            return (
              (fld.f_type.toLowerCase() !== 'image carousel' &&
                fld.f_type.toLowerCase() !== 'file attachments' &&
                fld.f_type.toLowerCase() !== 'Checkboxgroup' &&
                fld.f_type.toLowerCase() !== 'Complex Datatype' &&
                fld.name.toLowerCase() === 'sid') ||
              !fld.f_sysF
            );
          })
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        picklist.indexFields = indexFields;
        picklist.noImgFAFields = noImgFAFields;
        picklist.fields = fields;
        picklist.lookupFields = lookupFields;
        picklist.uniqueFields = uniqueFields;
        picklist.primaryFields = [...primaryFields];
        picklist.allFields = data.map((fld) => {
          return { sid: fld.sid, name: fld.fieldname };
        });
        picklist.allFieldsWithInfo = data;
      }
      this.store.dispatch(setPickupProperties({ picklist }));
      this.store.dispatch(setFieldsForTable({ tblFields: data }));
      this.loader.hide();
    } catch (e) {
      console.error(e);
      this.store.dispatch(setPickupProperties({ picklist }));
      this.loader.hide();
    }
  }
}
